import React, { useState, useEffect } from 'react';
import { Bell, BellRing } from 'lucide-react';
import { api } from '../../services/api';
import NotificationCenter from './NotificationCenter';

const NotificationBell: React.FC = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchUnreadCount();
    
    // Set up polling for unread count every 30 seconds
    const interval = setInterval(fetchUnreadCount, 30000);
    
    return () => clearInterval(interval);
  }, []);

  const fetchUnreadCount = async () => {
    try {
      setIsLoading(true);
      const response = await api.get('/notifications/unread-count');
      setUnreadCount(response.data.unread_count);
    } catch (error) {
      console.error('Error fetching unread count:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClick = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    // Refresh unread count when closing
    fetchUnreadCount();
  };

  return (
    <>
      <button
        onClick={handleClick}
        className="relative w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 border-gray-300 hover:border-[#008B8B] flex items-center justify-center text-gray-600 hover:text-[#008B8B] transition-all hover:scale-105 bg-white"
        aria-label="Notifications"
      >
        {unreadCount > 0 ? (
          <BellRing className="w-4 h-4 sm:w-5 sm:h-5" />
        ) : (
          <Bell className="w-4 h-4 sm:w-5 sm:h-5" />
        )}
        
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] sm:text-xs font-medium min-w-[1rem] sm:min-w-[1.2rem] h-4 sm:h-5 rounded-full flex items-center justify-center px-0.5 sm:px-1">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
        
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
      </button>

      <NotificationCenter isOpen={isOpen} onClose={handleClose} />
    </>
  );
};

export default NotificationBell;